module.exports = "<ng-content select=\"ic-card-header\"></ng-content>\r\n<ng-content select=\"ic-card-filter\"></ng-content>\r\n<div class=\"ic-card__body\">\r\n    <ng-content select=\"ic-card-menu\"></ng-content>\r\n    <ng-content select=\"ic-card-content\"></ng-content>\r\n</div>\r\n<ng-content select=\"ic-card-footer\"></ng-content>"


//////////////////
// WEBPACK FOOTER
// G:/3csoft/client-final/src/app/layout/card/card.component.html
// module id = ../../../../../src/app/layout/card/card.component.html
// module chunks = main